import React, { useEffect, useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import SelectListField from "../../../components/Fields/SelectListField";
import { FormConfig } from "../../../components/Fields/Types";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import ProductCategoryUserDefinedFieldModel from "../../../models/ProductCategoryUserDefinedFieldModel";
import DataService from "../../../services/data.service";
import { PopupProps } from "../../../types/PopupProps";
import { Result } from "../../../types/Result";

interface Props extends PopupProps {
    userDefinedFieldId: number
}

const AddUserDefinedFieldProductCategoryPopup: React.FC<Props> = ({ show, onHide, userDefinedFieldId }) => {
    const [serverErrors, setServerErrors] = useState<Result>({ isSuccesful: true, messages: [] });
    const { handleResult, handleException } = useNotifications();
    const [formData, setFormData] = useState<ProductCategoryUserDefinedFieldModel>();

    const productCategories = useSelectListOptions('api/v1/selectlist/ProductCategoryNameTrees?activeOnly=true', '-- Select category');

    useEffect(() => {
        setFormData({
            userDefinedFieldId: userDefinedFieldId,
            productCategoryId: 0,
            concurrencyId: ''
        } as ProductCategoryUserDefinedFieldModel);
    }, [])

    function submit() {
        if (formData) {
            DataService
                .create<ProductCategoryUserDefinedFieldModel>(`api/v1/ProductCategoryUserDefinedFields`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true) {
                        onHide();
                    }
                })
                .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'productCategoryId', label: 'Category', labelSize: 2, validationRules: [{ type: 'isRequired' }] },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'xl'} title={'Add product category'} >
            <Popup.Body>
                <SelectListField {...getFieldProps('productCategoryId')} options={productCategories} />
            </Popup.Body>
            <Popup.Footer>
                <SaveButton {...getSubmitButtonProps()} text='Add' />
            </Popup.Footer>
        </Popup>
    );
}
export default AddUserDefinedFieldProductCategoryPopup;